export default "__VITE_ASSET__DDa2f70Q__"